// extracted by mini-css-extract-plugin
export default {"container":"Logo_container__-Li6K","normal":"Logo_normal__r1LSs","multiple":"Logo_multiple__Ib-CL"};